import { render, staticRenderFns } from "./invite2020-11-11.vue?vue&type=template&id=10c6197c&scoped=true&"
import script from "./invite2020-11-11.vue?vue&type=script&lang=ts&"
export * from "./invite2020-11-11.vue?vue&type=script&lang=ts&"
import style0 from "./invite2020-11-11.vue?vue&type=style&index=0&id=10c6197c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6197c",
  null
  
)

export default component.exports